import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

function FacebookTags({ fbUrl, fbTitle, fbDescription, fbImage }) {
  return (
    <Helmet>
      {fbUrl && <meta property="og:url" content={fbUrl} />}
      {<meta property="og:type" content="article" />}
      {fbTitle && <meta property="og:title" content={fbTitle} />}
      {fbDescription && (
        <meta property="og:description" content={fbDescription} />
      )}
      {fbImage && <meta property="og:image" content={fbImage} />}
    </Helmet>
  );
}

FacebookTags.propTypes = {
  fbUrl: PropTypes.string,
  fbTitle: PropTypes.string,
  fbDescription: PropTypes.string,
  fbImage: PropTypes.string,
};

FacebookTags.defaultProps = {
  fbUrl: undefined,
  fbTitle: undefined,
  fbDescription: undefined,
  fbImage: undefined,
};

export default FacebookTags;



// WEBPACK FOOTER //
// ./src/components/shared/FacebookTags/FacebookTags.jsx